import React, { useContext } from 'react';
import TemplateProvider from 'app/pages/TemplateManagment/context';
import Panel from 'app/components/Layout/Panel';
import { Field } from 'formik';
import classes from './Style.module.scss';

// import POItem from './PoItem';
import POItems from './EnhancedPoItem';
import { InspectionContext } from 'app/pages/BookInspection/context/InspectionContext';

export const InspectionCriteriaContext = React.createContext<any>({});

const InspectionCriteria = () => {
  const { templates, onScrollTemplates } = useContext(InspectionContext);

  return (
    <InspectionCriteriaContext.Provider
      value={{
        templates: templates,
        onLoadMore: onScrollTemplates
      }}
    >
      <TemplateProvider>
        <Panel
          title="2. Inspection Criteria"
          className={classes.inspectionCriteria}
        >
          <Field name="inspectionPOItems">
            {({ field }) => {
              return <POItems className={classes.list} poItems={field.value} />;
            }}
          </Field>
        </Panel>
      </TemplateProvider>
    </InspectionCriteriaContext.Provider>
  );
};

export default InspectionCriteria;
